module.exports = __webpack_public_path__ + "img/01BryantHeights.b0e746ee.jpg";